import React from "react";
import { Helmet } from "react-helmet";

// Marks a private/utility page (login, admin dashboard) as not indexable. Used instead of a robots.txt
// Disallow: a crawler that is blocked by robots.txt never sees a noindex tag, so the page could still be indexed
// from external links. These pages are protected by authentication, not by this tag.
export default function NoIndex({ title }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
